import { LanguageSelect } from './language-select';
import { useUserLocale } from './user-locale-context';

/** El selector de idioma de la barra, cableado a `useUserLocale()`. */
export function UserLanguageSelect() {
  const { locale, setLocale, saveFailed } = useUserLocale();
  return (
    <LanguageSelect value={locale} onChange={(next) => void setLocale(next)} error={saveFailed} />
  );
}
